import React from 'react';
import i18next from 'i18next';
import styled, { css } from 'react-emotion';
import PropTypes from 'prop-types';

import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';
import { Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import externalRedirect from '~/modules/ecommerceCore/utils/externalRedirect';

const Icon = withDirection(styled.i`
  display: inline-block;
  ${props => (props.direction === 'rtl'
    && css`
        transform: rotate(-180deg);
  `)}
`);

const LinkContainer = styled(Row)`
  cursor: pointer;
`;

const BuyingOptionsLink = ({ vendor }) => (
  <LinkContainer onClick={() => externalRedirect(urlFor('getProductDetailsLink', [vendor[0].slug, vendor[0].vendor_variants_count, vendor[0].min_variant?.vendor]), '_blank')}>
    <Label size={['xs', 'xs', 'md', 'md']} secondary sm>
      {i18next.t('ecommerceCoreUI:Product.buyingOptionsLink')}
      &nbsp;
      <Icon className="el-icon el-icon-right" />
    </Label>
  </LinkContainer>
);

BuyingOptionsLink.propTypes = {
  vendor: PropTypes.shape({}).isRequired,
};

export default BuyingOptionsLink;
